export default function CKeywords() {
  return <h2>C Keywords</h2>;
}
